module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-youtube-0094a416f35e72a4fb09f2fc45d4e1a2.png";